import { render, staticRenderFns } from "./EmotionMoodChartDemo.vue?vue&type=template&id=6505e89e&scoped=true"
import script from "./EmotionMoodChartDemo.vue?vue&type=script&lang=js"
export * from "./EmotionMoodChartDemo.vue?vue&type=script&lang=js"
import style0 from "./EmotionMoodChartDemo.vue?vue&type=style&index=0&id=6505e89e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505e89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6505e89e')) {
      api.createRecord('6505e89e', component.options)
    } else {
      api.reload('6505e89e', component.options)
    }
    module.hot.accept("./EmotionMoodChartDemo.vue?vue&type=template&id=6505e89e&scoped=true", function () {
      api.rerender('6505e89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/EmotionMoodChartDemo.vue"
export default component.exports